export default __webpack_public_path__ + "static/media/welness.b8ea93fc.jpeg";